export default __webpack_public_path__ + "static/media/background3.f6078fa6.png";